import Styles from 'components/Wizards/Wizard/Header/MobileHeader.module.scss'
import { Stepper } from 'components/Wizards/Stepper/Stepper'
import { HeaderProps } from 'components/Wizards/Wizard/Header/Types'
import { useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'

export const MobileHeader = ({
  steps,
  currentStep = 1,
  onStepPress,
  title,
  icon: Icon,
  completedAll,
}: Omit<HeaderProps, 'previewUrl'>) => {
  const { closeModal } = useModals()

  return (
    <div className={Styles.root} data-theme="light">
      <div className={Styles.topBarContainer}>
        <div />
        <div className={Styles.titleContainer}>
          {!!Icon && <Icon size={20} />}
          <h4 className={Styles.title}>{title}</h4>
        </div>
        <div className={Styles.cancelContainer}>
          <Button variant="ghost" size="lg" onPress={closeModal}>
            Cancel
          </Button>
        </div>
      </div>
      {steps.length > 1 && (
        <div className={Styles.stepperContainer}>
          <Stepper.Root current={currentStep} completedAll={completedAll}>
            {steps.map((step, i) => (
              <Stepper.Step key={`${step}_${i}`} onPress={() => onStepPress?.(i + 1)}>
                {step}
              </Stepper.Step>
            ))}
          </Stepper.Root>
        </div>
      )}
    </div>
  )
}
